import Modal from './Modal'
import Button from './Button'

const footerCls = 'flex flex-col-reverse sm:flex-row gap-2 pt-4 border-t border-border/70'
const btnCls = 'w-full sm:w-auto h-11'

export function ConfirmModal({
  isOpen,
  onClose,
  title,
  body,
  primaryLabel,
  primaryVariant = 'destructive',
  onPrimary,
  secondaryLabel = 'Cancel',
}: {
  isOpen: boolean
  onClose: () => void
  title: string
  body: React.ReactNode
  primaryLabel: string
  primaryVariant?: 'default' | 'destructive' | 'outline'
  onPrimary: () => void
  secondaryLabel?: string
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className='space-y-6'>
        <div className='space-y-2'>{body}</div>
        <div className={footerCls}>
          <Button variant='outline' onClick={onClose} className={btnCls}>{secondaryLabel}</Button>
          <Button variant={primaryVariant} onClick={onPrimary} className={btnCls}>{primaryLabel}</Button>
        </div>
      </div>
    </Modal>
  )
}

export function ModalFooter({
  secondaryLabel,
  onClose,
  primaryLabel,
  onPrimary,
  primaryDisabled,
}: {
  secondaryLabel?: string
  onClose: () => void
  primaryLabel?: string
  onPrimary?: () => void
  primaryDisabled?: boolean
}) {
  return (
    <div className={footerCls}>
      <Button variant='outline' onClick={onClose} className={btnCls}>{secondaryLabel ?? 'Cancel'}</Button>
      {primaryLabel && <Button onClick={onPrimary} disabled={primaryDisabled} className={btnCls}>{primaryLabel}</Button>}
    </div>
  )
}
